import styled from 'styled-components';

const StyledContent = styled.div`
  .identity__field.PhoneInput {
    margin-bottom: 16px;

    &.with-error {
      margin-bottom: 32px;
    }
  }
  .identity__field .PhoneInputInput {
    margin: 0;
  }
  .identity__field .PhoneInputInput input {
    border-top-left-radius: 0;
  }
  .identity__field .PhoneInputCountry {
    background-color: #f8f8f8;
    width: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0;
    border-right: 1px solid #dfdfdf;
    border-top-left-radius: 5px;
  }
  .identity__field .PhoneInputCountry .PhoneInputCountrySelectArrow {
    display: none;
  }
  .identity__field .PhoneInputCountry .PhoneInputCountryIcon {
    width: 32px;
    height: auto;
    box-shadow: none;
  }
`;

export default StyledContent;
